export default "<div class=\"side-nav-bar\">\n    <acl-ngx-form-nav [items]=\"tabs\" [activeItem]=\"activeTabName\"></acl-ngx-form-nav>\n</div>"